import { ReactComponent as Error404 } from "#src/assets/images/illustrations/error-404.svg";
import { pathname } from "#src/config/pathname";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const Error404Content = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "errors",
  });

  return (
    <>
      <Error404 />
      {t("notFound")}
      <p>
        <Trans
          t={t}
          i18nKey={"clickHereToHome"}
          components={{
            a: <Link to={pathname.HOME} className="contents"></Link>,
          }}
        />
      </p>
    </>
  );
};
